import { Injectable } from '@angular/core';
import { Settings } from '../../lib/app.constant';

@Injectable({
  providedIn: 'root',
})
export class StatusColorService {

  // private colorMap: any = {};

  // Default fallback colors
  private defaultColors: any = {
    active: {
      color: '#22c55e', // green
      highlight: 0,
    },
    inactive: {
      color: '#ef4444', // red
      highlight: 0,
    },
    'waiting for acknowledgment': {
      color: '#eab308', // yellow
      highlight: 1,
    },
    pending: {
      color: '#facc15', // yellow
      highlight: 0,
    },
    completed: {
      color: '#16a34a', // green
      highlight: 0,
    },
    error: {
      color: '#dc2626', // red
      highlight: 1,
    },
    successful: {
      color: '#22c55e', // green
      highlight: 0,
    },
    success: {
      color: '#22c55e', // green
      highlight: 0,
    },
    'in progress': {
      color: '#f59e0b', // amber
      highlight: 0,
    },
  };

  private colorMap: any = { ...this.defaultColors };

  setStatusColors(data: any[]) {

    // First set default colors
    this.colorMap = { ...this.defaultColors };

    // Then override with API data if available
    if (Array.isArray(data) && data.length) {

      data.forEach((item) => {

        if (item?.name) {
          this.colorMap[item.name.toLowerCase()] = {
            color: item.color_code || this.defaultColors[item.name.toLowerCase()]?.color || '#6b7280',
            highlight: item.highlight ?? 0,
            status_code: item.status_code,
            event: Settings.StatusEvent.normalize(item.event),
          };
        }

      });
    }
  }

  /**
   * Allowed actions/events (EVENT_ENUM codes) configured for a status in
   * Status Management. Returns [] when the status is unknown or has no events
   * configured, which means "render no action buttons".
   */
  getEvents(statusName: string): number[] {

    if (!statusName) {
      return [];
    }

    return (
      this.colorMap[statusName.toLowerCase()]?.event || []
    );
  }

  hasEvent(statusName: string, event: number): boolean {
    return this.getEvents(statusName).includes(event);
  }

  // Color get karo
  getColor(statusName: string): string {

    if (!statusName) {
      return '#6b7280';
    }

    return (
      this.colorMap[statusName.toLowerCase()]?.color || '#6b7280'
    );
  }

  // Highlight check
  isHighlight(statusName: string): boolean {

    if (!statusName) {
      return false;
    }

    return (
      this.colorMap[statusName.toLowerCase()]?.highlight === 1
    );
  }
}